<template>
  <div :class="[`x3-3`, className || ``]">
    <div class="text-143 prostoone-normal-white-9px">АКАДЕМИЯ</div>
    <img class="image-2" :src="image" alt="image" />
  </div>
</template>

<script>
export default {
  name: "X3",
  props: ["image", "className"],
};
</script>

<style>
.x3-3 {
  aspect-ratio: 1.79;
  height: 72px;
  left: 3px;
  position: absolute;
  top: 0;
  width: 131px;
}

.text-143 {
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  align-items: flex-end;
  display: -webkit-box;
  height: 12px;
  justify-content: center;
  left: 63px;
  letter-spacing: 0;
  line-height: normal;
  overflow: hidden;
  position: absolute;
  text-overflow: ellipsis;
  top: 60px;
  width: 65px;
}

.image-2 {
  aspect-ratio: 2.03;
  height: 64px;
  left: 0;
  position: absolute;
  top: 0;
  width: 129px;
}

.x3-3.x3-4 .image-2,
.x3-3.x3-5 .image-2,
.x3-3.x3-7 .image-2,
.x3-3.x3-8 .image-2,
.x3-3.x3-9 .image-2,
.x3-3.x3-11 .image-2,
.x3-3.x3-13 .image-2,
.x3-3.x3-14 .image-2,
.x3-3.x3-15 .image-2 {
  aspect-ratio: 2.03;
  height: 63px;
}
</style>
